<div>
  <form [formGroup]="form">
    <side-panel-header [title]="'Timesheet filters' | translate" (closed)="close()" />

    @if (!isListView()) {
      <div class="flex flex-col gap-xs p-md text-default" formGroupName="show">
        @for (field of showOptions; track field) {
          @if (!periodPage || field.showOnPeriod) {
            <sb-checkbox [formControlName]="field.field">{{ field.label }}</sb-checkbox>
          }
        }
      </div>

      <sidebar-header [title]="'Status' | translate" />
      <div class="flex flex-col gap-xs p-md text-default" formGroupName="status">
        @for (field of statusOptions; track field) {
          <sb-checkbox [formControlName]="field.field">{{ field.label }}</sb-checkbox>
        }
      </div>

      <sidebar-header [title]="'Type' | translate" />
      <div class="flex flex-col gap-xs p-md text-default" formGroupName="type">
        @for (field of typeOptions; track field) {
          <sb-checkbox [formControlName]="field.field">{{ field.label }}</sb-checkbox>
        }
      </div>

      <sidebar-header [title]="'Conflicts' | translate" />
      <div class="flex flex-col gap-xs p-md text-default" formGroupName="type">
        @for (field of conflictOptions; track field) {
          <sb-checkbox [formControlName]="field.field">{{ field.label }}</sb-checkbox>
        }
      </div>
    }

    @if (!!columns) {
      <sidebar-header [title]="'Columns' | translate" />
      <div class="flex flex-col gap-xs p-md text-default" formGroupName="columns">
        @for (column of columnOptions(); track column.field) {
          <sb-checkbox [formControlName]="column.field">{{ column.label | translate }}</sb-checkbox>
        }
      </div>
    }

    @if (!isListView() && customFieldOptions?.length > 0 && form.controls['customFields']) {
      <sidebar-header [title]="'Custom fields' | translate" />
      <div class="flex flex-col gap-xs p-md text-default" formGroupName="customFields">
        @for (column of customFieldOptions; track column) {
          <sb-checkbox [formControlName]="column.field">{{ column.label | translate }}</sb-checkbox>
        }
      </div>
    }
  </form>
</div>
